import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  id: string;
  link: string;
  img: string;
  title: string;
};

const MaterialsLink = (props: Props) => {
  const { img, link, title } = props;
  return (
    <Link to={link} className="materials__link">
      <img src={img} alt={title} className="materials__img" />
      {(title && (
        <h3
          className="materials__title"
          dangerouslySetInnerHTML={{ __html: title }}
        ></h3>
      )) ||
        ''}
    </Link>
  );
};

export default MaterialsLink;
